import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var newApi = function newApi(_ref) {
  var amsResponse = _ref.amsResponse;
  return {
    getRentObjectTypes: function () {
      var _getRentObjectTypes = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var contractType, stationId, pickupStationId, data, classifications, rentObjects;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contractType = _ref2.contractType, stationId = _ref2.stationId, pickupStationId = _ref2.pickupStationId;
              _context.next = 3;
              return amsResponse.getData({
                method: "GET",
                path: "v1.1/dispo/rentObjTypes",
                query: {
                  contractType: contractType,
                  station: stationId,
                  pickupStation: pickupStationId
                }
              });
            case 3:
              data = _context.sent;
              classifications = data.classifications || [];
              rentObjects = data.rentObjects || [];
              return _context.abrupt("return", {
                classifications: classifications,
                rentObjects: rentObjects.map(function (rentObject) {
                  return _objectSpread(_objectSpread({}, rentObject), {}, {
                    properties: rentObject.properties || [],
                    rentObjTypeImageList: rentObject.rentObjTypeImageList || []
                  });
                })
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getRentObjectTypes(_x) {
        return _getRentObjectTypes.apply(this, arguments);
      }
      return getRentObjectTypes;
    }()
  };
};